import axios from "axios";
import { AppDispatch } from "../Store";
import { identificationSlice } from "../reducers/IdentificationSlice";
import { GET_IDENTIFICATION_API } from "./endpoints";
import { IIdentification } from "../types/IdentificationTypes";

export const getIdentificationInfo =
  (passportNumber: string) => async (dispatch: AppDispatch) => {
    const trimmedPassportNumber = passportNumber.trim();

    if (!trimmedPassportNumber) {
      dispatch(
        identificationSlice.actions.identificationFailed(
          "Введите серию и номер паспорта"
        )
      );
      return;
    }

    try {
      dispatch(identificationSlice.actions.identificationLoading());

      const res = await axios.post<IIdentification>(
        GET_IDENTIFICATION_API,
        { passportNumber: trimmedPassportNumber },
        {
          withCredentials: true,
        }
      );

      dispatch(identificationSlice.actions.identificationSuccess(res.data));
    } catch (error: any) {
      dispatch(
        identificationSlice.actions.identificationFailed(
          error.response?.data?.message || error.message || "Something went wrong"
        )
      );
    }
  };